import actions from './banner.actions'
import getters from './banner.getters'
import mutations from './banner.mutations'

// Initial state
const state = {
  banners: [],
  bannerDetails: {},
  editableBannerFields: {},
  isBannerLoading: false,
  searchTerm: '',
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}



// WEBPACK FOOTER //
// ./src/store/modules/banner/index.js